import React, { useState, useEffect } from "react";
import NavBar from "./NavBar";
import "./Home.css";
import { Button, FormControl, Input, InputLabel, FormHelperText } from '@material-ui/core';
import db from "./firebase";
import Footer from "./Footer";
import CloseIcon from '@material-ui/icons/Close';
import firebase from "firebase"
import { Link } from 'react-router-dom';

function Home() {

	const [homePageFood, setHomePageFood] = useState([]);
	const [payment, setPayment] = useState(false);
	const [foodCart, setFoodCart] = useState([]);
	let [totalPriceOfFood, setTotalPriceOfFood] = useState(0);

	//place order details
	const [placeOrderName, setPlaceOrderName] = useState('');
	const [placeOrderEmail, setPlaceOrderEmail] = useState('');
	const [placeOrderDeliveryAddress, setPlaceOrderDeliveryAddress] = useState('');
	const [placeOrderPhoneNumber, setPlaceOrderPhoneNumber] = useState('');
	const [orderedFood, setOrderedFood] = useState([]);

	//reserve table details
	const [reserveTableUserName, setReserveTableUserName] = useState('');
	const [reserveTableEmail, setReserveTableEmail] = useState('');
	const [reserveTableContactNumber, setReserveTableContactNumber] = useState('');
	const [reserveTableArrivalTime, setReserveTableArrivalTime] = useState('');
	const [reserveTableTotalNumPpl, setReserveTableTotalNumPpl] = useState('');
	const [reserveTableArrivalDate, setReserveTableArrivalDate] = useState('');

	useEffect(() => {
		db.collection("homePageFood").onSnapshot(snapshot => {
			setHomePageFood(snapshot.docs.map(doc => doc.data()))
		})
	}, [])

	const showPayment = () => {
		const paymentWindow = document.querySelector(".home__foodCartCheckoutfinal");
		paymentWindow.classList.toggle("home__activeFoodCartCheckoutfinal");
		setPayment(!payment)
	} 

	const activeFoodCart = () => {
		const homeFoodCart = document.querySelector(".home__foodCart");

		homeFoodCart.classList.toggle("home__activeFoodCart")
	}

	const addItemToTheCart = ({foodImg, foodName, foodPrice}) => {
		setFoodCart([...foodCart, {foodImg, foodName, foodPrice}]);
		const priceOfFood = parseInt(foodPrice);
		setOrderedFood([...orderedFood, {foodImg, foodPrice, foodName}]);
		setTotalPriceOfFood(totalPriceOfFood += priceOfFood);
	}

	const showReserveTableForm = () => {
		const homHomePageReserveTableContainer = document.querySelector(".home__homePageReserveTableContainer");

		homHomePageReserveTableContainer.classList.toggle("home__activeHomePageReserveTableContainer");		
	}

	const showOrderPlacedMsg = () => {
		const homePagePlacedOrderMessageContainer = document.querySelector(".home__homePagePlacedOrderMessageContainer");

		homePagePlacedOrderMessageContainer.classList.toggle("home__activeHomePagePlacedOrderMessageContainer");
	}

	const placeOrder = () => {
		db.collection("orders").add({
			orderName: placeOrderName,
			orderEmail: placeOrderEmail,
			orderDeliveryAddress: placeOrderDeliveryAddress,
			orderFood: orderedFood,
			orderPrice: totalPriceOfFood,
			orderPhoneNumber: placeOrderPhoneNumber,
			timestamp: firebase.firestore.FieldValue.serverTimestamp()
		}).then(() => {
			showOrderPlacedMsg();
			setTotalPriceOfFood(0);
			setFoodCart([]);
			setPlaceOrderName('');
			setPlaceOrderEmail('');
			setPlaceOrderDeliveryAddress('');
			setPlaceOrderPhoneNumber('');
			setOrderedFood([]);
		})
	}

	const showReserveTableMsg = () => {
		const homeReservedTableMsgContainer = document.querySelector(".home__reservedTableMsgContainer");

		homeReservedTableMsgContainer.classList.toggle("home__activeReservedTableMsgContainer")
	}

	const reserveTable = () => {
		db.collection("reservedTables").add({
			userName: reserveTableUserName,
			userEmail: reserveTableEmail,
			userArrivalDate: reserveTableArrivalDate,
			userContactNumber: reserveTableContactNumber,
			userArrivalTime: reserveTableArrivalTime,
			totalNumberOfPeople: reserveTableTotalNumPpl,
			timestamp: firebase.firestore.FieldValue.serverTimestamp()
		}).then(() => {
			showReserveTableForm();
			showReserveTableMsg();
			setReserveTableUserName('');
			setReserveTableEmail('');
			setReserveTableContactNumber('');
			setReserveTableArrivalTime('');
			setReserveTableTotalNumPpl('');
			setReserveTableArrivalDate('');
		})
	}

	return (
		<div className="home">
			<NavBar page="home"/>
			<div className="home__homePage">
				<div className="home__homePageMainContent">
					<div className="home__homePageMenuTxt"> menu </div>	
					<div className="home__homePageWelcomeTxt" style={{color: "#808080"}}> Welcome </div>
					<div className="home__homePageContentButtons">
						<Button variant="contained" onClick={showReserveTableForm}> Reserve Table </Button>
						<Link to="/Menu">
							<Button className="home__homePageButton2"> browse menu </Button>
						</Link>
					</div>
					<div className="home__homePagePlacedOrderMessageContainer">
						<div className="home__homePagePlacedOrderMessage">
							<div className="orderPlacedTxt"> Order Placed </div>
							<Button variant="contained" color="primary" onClick={showOrderPlacedMsg}> Okay </Button>
						</div>
					</div>

					<div className="home__reservedTableMsgContainer">
						<div className="home__reservedTable">
							<div className="home__reservedTableTxt"> Table Reserved </div>
							<Button variant="contained" color="primary" onClick={showReserveTableMsg}> Okay </Button>
						</div>
					</div>
				</div>
			{/* 
				const [reserveTableUserName, setReserveTableUserName] = useState('');
	const [reserveTableEmail, setReserveTableEmail] = useState('');
	const [reserveTableContactNumber, setReserveTableContactNumber] = useState('');
	const [reserveTableArrivalTime, setReserveTableArrivalTime] = useState('');
	const [reserveTableTotalNumPpl, setReserveTableTotalNumPpl] = useState('');
			*/}
				<div className="home__homePageReserveTableContainer">
					<div className="home__homePageReserveTableForm">
						<FormControl className="home__homePageRserveTableFormInput">
							<InputLabel htmlFor="reserveTable__userName"> Your name </InputLabel>
							<Input value={reserveTableUserName} onChange={event => setReserveTableUserName(event.target.value)} id="reserveTable__userName"/>
						</FormControl>
						<FormControl className="home__homePageRserveTableFormInput">
							<InputLabel htmlFor="reserveTable__emailAddress"> Email Address </InputLabel>
							<Input value={reserveTableEmail} onChange={event => setReserveTableEmail(event.target.value)} id="reserveTable__userName"/>
						</FormControl>
						<FormControl className="home__homePageRserveTableFormInput">
							<InputLabel htmlFor="reserveTable__userName"> Contact Number </InputLabel>
							<Input value={reserveTableContactNumber} onChange={event => setReserveTableContactNumber(event.target.value)} id="reserveTable__userName"/>
						</FormControl>
						<FormControl className="home__homePageRserveTableFormInput">
							<InputLabel htmlFor="reserveTable__userName"> Arrival Date </InputLabel>
							<Input value={reserveTableArrivalDate} onChange={event => setReserveTableArrivalDate(event.target.value)} type="date" id="reserveTable__userName"/>
						</FormControl>
						<FormControl className="home__homePageRserveTableFormInput">
							<InputLabel> ArrivalTime </InputLabel>
							<Input value={reserveTableArrivalTime} onChange={event => setReserveTableArrivalTime(event.target.value)} type="time"/>
						</FormControl>
						<FormControl className="home__homePageRserveTableFormInput">
							<InputLabel htmlFor="reserveTable__userName"> Total Number of persons </InputLabel>
							<Input value={reserveTableTotalNumPpl} onChange={event => setReserveTableTotalNumPpl(event.target.value)} type="number" id="reserveTable__userName"/>
						</FormControl>
						<Button variant="contained" color="primary" onClick={reserveTable}> Reserve Table </Button>
						<CloseIcon className="home__homePageReserveTableFormCloseIcon" onClick={showReserveTableForm}/>
					</div>
				</div>
			</div>
			<div className="home__homePageFood">
				{
					homePageFood.map(food => {
						return (
							<div className="home__homePageMainFood">
								<div className="home__homePageMainFoodImgContainer">
									<img src={food.foodImg}  className="home__homePageMainFoodImg"/>
									<div className="home__homePageFoodPrice"> ${food.foodPrice}</div>
								</div>
								<div className="home__homePageMainFoodName"> {food.foodName} </div>
								<div className="home__homePageMainFoodSmallDesc"> {food.shortDescAbtFood} </div>
								<div className="home__homePageMainFoodButtons">
									<Button variant="contained" color="primary"> Order now </Button>
									<Button
									variant="contained"
									color="secondary"
									onClick={() => addItemToTheCart({foodImg: food.foodImg, foodName: food.foodName, foodPrice: food.foodPrice})}>
									 Add to cart
									</Button>
								</div>
							</div>
						)
					})
				}

				<div className="home__foodCart">
					<div className="home__foodCartAddedFoods">
						{
							foodCart.map(food => {
								return (
									<div className="home__foodCartAddedFood">
										<img src={food.foodImg} className="home__foodCartAddedFoodImg"/>
										<div className="home__foodCartAddedFoodNameContainer">
											<div className="home__foodCartAddedFoodName"> {food.foodName} </div>
											<div className="home__foodCartAddedFoodPrice"> ${food.foodPrice} </div>
										</div>
									</div>
								)
							})
						}

					</div>

					<div className="home__foodCartCheckoutfinal">
						<div className="home__paymentTotalPriceTxt"> Total price </div>
						<div className="home__paymentTotalPrice"> ${totalPriceOfFood + 5} </div>
						<CloseIcon className="home__foodCartCheckoutCloseIcon" onClick={showPayment}/>
						<FormControl className="home__paymentInputs">
							<InputLabel htmlFor="my-input">User Name</InputLabel>
							<Input type="text" value={placeOrderName} onChange={event => setPlaceOrderName(event.target.value)} id="my-input" aria-describedby="my-helper-text" />
						</FormControl>
						<FormControl className="home__paymentInputs">
							<InputLabel htmlFor="my-input">Email Address</InputLabel>
							<Input type="email" value={placeOrderEmail} onChange={event => setPlaceOrderEmail(event.target.value)} id="my-input" aria-describedby="my-helper-text" />
						</FormControl>
						<FormControl className="home__paymentInputs">
							<InputLabel htmlFor="my-input">Delivery Address</InputLabel>
							<Input type="text" value={placeOrderDeliveryAddress} onChange={event => setPlaceOrderDeliveryAddress(event.target.value)} id="my-input" aria-describedby="my-helper-text" />
						</FormControl>
						<FormControl className="home__paymentInputs">
							<InputLabel htmlFor="my-input">Phone Number</InputLabel>
							<Input type="text" value={placeOrderPhoneNumber} onChange={event => setPlaceOrderPhoneNumber(event.target.value)} id="my-input" aria-describedby="my-helper-text" />
						</FormControl>
						<Button variant="contained" color="primary" onClick={placeOrder}> Place Order </Button>
					</div>

					<div className="home__foodCartCheckout">
						<div className="home__foodCartItemPrices">
							<div className="home__foodCartCheckoutChildren"> <div> Total price </div> : <div> ${totalPriceOfFood} </div> </div>
							<div className="home__foodCartCheckoutChildren"> <div> Shpping Fee </div> : <div> $5 </div> </div>
							<div className="home__foodCartCheckoutChildren"> <div> Total Price </div> : <div> ${totalPriceOfFood + 5} </div> </div>
						</div>
						<Button variant="contained" color="secondary" onClick={showPayment}> Checkout </Button>
					</div>
					<CloseIcon className="home__foodCartCloseIcon" onClick={activeFoodCart}/>
				</div>				
			</div>

			<Footer />
		</div>
	)
}

export default Home;